import React from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { Button } from 'antd';
import dayjs from 'dayjs';
import { ISearchSafetyStockReportRes } from '@/interfaces/report';
import { ExportOutlined } from '@ant-design/icons';

interface IProps {
  data: ISearchSafetyStockReportRes[];
}

const ExcelExport = ({ data }: IProps) => {
  const handleExport = async () => {
    // Create a new workbook and add a worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    // Add custom headers with color
    worksheet.columns = [
      { header: '#', key: 'id', width: 10 },
      { header: 'รหัสสินค้า', key: 'productCode', width: 20 },
      { header: 'ชื่อสินค้า', key: 'productName', width: 40 },
      { header: 'จำนวน', key: 'remainStock', width: 15 },
      { header: 'หน่วย', key: 'unitNameTH', width: 10 },
      { header: 'Safety Stock', key: 'safetyStock', width: 20 },
      { header: 'Diff', key: 'diff', width: 20 },
      { header: 'รอส่ง', key: 'orderDraftQty', width: 20 },
      { header: '1 month', key: 'orderQty1', width: 20 },
      { header: '3 month (AVG)', key: 'orderQty2', width: 20 },
    ];

    // Style the header row
    worksheet.getRow(1).eachCell(cell => {
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } }; // White text
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF0000FF' }, // Blue background
      };
    });

    // Add data to the worksheet
    data.forEach((item, index) => {
      const rowIndex = index + 2;
      worksheet.addRow({
        ...item,
        id: index + 1,
        diff: Number(item.remainStock - item.safetyStock),
      });
      const safetyCell = worksheet.getCell(`F${rowIndex}`);
      if (item.remainStock < item.safetyStock) {
        safetyCell.font = { color: { argb: 'FFFF0000' } };
      }
      const monthCell = worksheet.getCell(`G${rowIndex}`);
      if (item.remainStock < item.orderQty1) {
        monthCell.font = { color: { argb: 'FFFF0000' } };
      }
      const month3Cell = worksheet.getCell(`H${rowIndex}`);
      if (item.remainStock < item.orderQty2) {
        month3Cell.font = { color: { argb: 'FFFF0000' } };
      }
    });

    // Generate the Excel file and trigger the download
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `safety-stock-report-${dayjs().format('YYYY-MM-DD')}.xlsx`);
  };

  return (
    <div>
      <Button type="primary" ghost onClick={handleExport}>
        <ExportOutlined /> Export to Excel
      </Button>
    </div>
  );
};

export default ExcelExport;
